import { render, staticRenderFns } from "./dev-header.vue?vue&type=template&id=432d0ea6"
import script from "./dev-header.vue?vue&type=script&lang=js"
export * from "./dev-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports